import React, { useEffect, useState, useContext } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { HomeContainer, FirstSectionContainer, SectionsContainer, CenterSliderContainer, LastSliderContainer, LastSectionsContainer, ArrowContainer } from "./HomeStyled";
import { FormattedMessage } from 'react-intl';
import { UserContext } from "../../context/userContext";

import juanvaldez from './../../utils/images/collaboration/juan_valdez.jpg';
import portada1 from './../../utils/images/collaboration/laura_sanchez.png';
import company1 from './../../utils/images/collaboration/Imagen_vogue.png';
import portada2 from './../../utils/images/collaboration/perfil_redes.jpg';
import company2 from './../../utils/images/collaboration/vogue.jpg';

import { getCategories, getNetworks } from "../../api/filtersApi";
import { getAllInfluencersFilter, getFeaturedInfluencers, getNewInfluencers } from "../../api/influencerApi";
import { getAllCompanies } from "../../api/companyApi";

import Banner from "../../components/Banner/Banner";
import FilterBar from "../../components/FilterBar/FilterBar";
import InfluencerCard from './../../components/InfluencerCard/InfluencerCar';
import CompanyCard from "./../../components/CompanyCard/CompanyCard";
import CollaborationCard from "../../components/CollaborationCard/CollaborationCard";
import FilterCard from "../../components/FilterCard/FilterCard";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FiltersContext } from "../../context/filtersContext";


function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
        <ArrowContainer onClick={onClick} style={{ left: '-50px' }}>
            <i className="fa-solid fa-angle-left" ></i>
        </ArrowContainer>

    );
}

function SampleNextArrow(props) {
    const { onClick } = props;
    return (
        <ArrowContainer onClick={onClick} style={{ right: '-50px' }}>
            <i className="fa-solid fa-angle-right" ></i>
        </ArrowContainer>
    );
}

export default function Home() {

    const [categoriesOptions, setCategoriesOptions] = useState([]);
    const [networksOptions, setNetworksOptions] = useState([]);

    const navigate = useNavigate();

    const { companyId, userToken, userType } = useContext(UserContext);
    const { featuredFilter, setFeaturedFilter, newUserFilter, setNewUserFilter, setLanguageFilter, setRatingFilter, setVerifiedFilter, setGenderFilter, setAgeFilter, setNetworkFilter, setCategoryFilter, setCountryFilter, setPriceFilter, setQueryPrice, setQueryPriceId, setInputFilter, setOrderBy } = useContext(FiltersContext);


    const [newInfluencers, setNewInfluencers] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [featuredInfluencers, setFeaturedInfluencers] = useState([]);

    const [limit, setLimit] = useState(5);

    useEffect(() => {
        getCategories().then((response) => {
            setCategoriesOptions(response);
        })

        getNetworks().then((response) => {
            response.map((respo) => {
                respo['nombre'] = respo.name;
            })
            setNetworksOptions(response);
        })

        /* getNewInfluencers({ companyId: companyId, limit: limit, offset: 0 }).then(({ data, pagination }) => {
            setNewInfluencers(data)
        }) 

        getFeaturedInfluencers({ companyId: companyId, limit: limit, offset: 0 }).then(({ data, pagination }) => {
            setFeaturedInfluencers(data)
        })*/

        getAllInfluencersFilter({ companyId: companyId, query: '&newuser=eq.true', limit: limit, offset: 0 }).then(({ data, pagination }) => {
            setNewInfluencers(data)
        })

        getAllInfluencersFilter({ companyId: companyId, query: '&featured=eq.true', limit: limit, offset: 0 }).then(({ data, pagination }) => {
            setFeaturedInfluencers(data)
        })



        getAllCompanies({ limit: limit, offset: 0 }).then(({ data, pagination }) => {
            setCompanies(data)
        })

        setFeaturedFilter(false);
        setNewUserFilter(false);
        setLanguageFilter([]);
        setRatingFilter(null);
        setVerifiedFilter([]);
        setGenderFilter([]);
        setAgeFilter([]);
        setNetworkFilter([]);
        setCategoryFilter([]);
        setCountryFilter([]);
        setPriceFilter([]);
        setQueryPrice([]);
        setQueryPriceId([]);
        setInputFilter('');
        setOrderBy('')

    }, [])



    /**-----Esto vendra del back---------- */
    const collaborations = [
        {
            id: 1,
            frontImg: portada1,
            name: "Laura",
            companyImg: company1
        },
        {
            id: 2,
            frontImg: portada2,
            name: "Kmila",
            companyImg: juanvaldez
        },
        {
            id: 3,
            frontImg: portada1,
            name: "Laura",
            companyImg: company2
        },
        {
            id: 4,
            frontImg: portada2,
            name: "Karen",
            companyImg: company1
        }
    ];


    const settingSliderCategories = {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        /*  prevArrow: <SamplePrevArrow />, */
        accessibility: true,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    className: "center",
                    centerMode: true,
                    infinite: true,
                    centerPadding: "60px",
                }
            }
        ]

    };

    const settingSliderNetwork = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        //prevArrow: <SamplePrevArrow />,
        accessibility: true,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 620,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    className: "center",
                    centerMode: true,
                    infinite: true,
                    centerPadding: "60px",
                }
            }
        ]
    };



    return (
        <HomeContainer>

            <Banner />

            <FilterBar />

            <FirstSectionContainer>
                <div className="subtitle">
                    <h2>
                        <FormattedMessage id="home_title_1" defaultMessage="Influencers destacados" />
                    </h2>
                    <p className="seeMore" onClick={() => {
                        setFeaturedFilter(true)
                        navigate('/influencers')
                    }}>
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </p>
                </div>

                <div className="content">
                    <div className="cards influencers">
                        {featuredInfluencers.map((influencer) => (
                            <InfluencerCard influencer={influencer} key={influencer.id} page='home' />
                        ))}
                    </div>
                    <p className="seeMoreMobile" onClick={() => {
                        setFeaturedFilter(true)
                        navigate('/influencers')
                    }}>
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </p>
                </div>

            </FirstSectionContainer>

            < SectionsContainer>
                <div className="subtitle">
                    <h2>
                        <FormattedMessage id="home_title_2" defaultMessage="Empresas en Fluincr" />
                    </h2>
                    {(userToken === null) ? (<Link to={"/signin"}>
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </Link>) : (userType === "influencer") ? (<Link to={"/companies"}>
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </Link>) : ('')}
                </div>
                <div className="content">
                    <div className="cards companies">
                        {companies.map((company) => (
                            <CompanyCard company={company} key={company.id} page='home' />
                        ))}
                    </div>
                    {(userToken === null) ? (<Link to={"/signin"} className="seeMoreMobile">
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </Link>) : (userType === "influencer") ? (<Link to={"/companies"} className="seeMoreMobile">
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </Link>) : ('')}
                </div>
            </ SectionsContainer>

            < CenterSliderContainer>
                <div className="subtitle">
                    <h2>
                        <FormattedMessage id="home_title_3" defaultMessage="Categorías" />
                    </h2>
                </div>
                <div className="sliderContainer" >
                    < Slider {...settingSliderCategories}>
                        {
                            categoriesOptions.map((category) => (
                                <FilterCard filter={category} key={category.id} type={'category'} />
                            ))
                        }
                    </Slider >
                </div>
            </ CenterSliderContainer >

            {/* < SectionsContainer>
                <div className="subtitle">
                    <h2 className="collaborationsTitle">
                        <FormattedMessage id="home_title_4" defaultMessage="Colaboraciones éxitosas" />
                    </h2>
                    <Link to={"#"}>
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </Link>
                </div>

                <div className="content collaborations">

                    <div className="cards ">
                        {collaborations.map((collaboration) => (
                            <CollaborationCard collaboration={collaboration} key={collaboration.id} />
                        ))}
                    </div>
                    <Link to={"#"} className="seeMoreMobile">
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </Link>
                </div>
            </ SectionsContainer> */}

            < SectionsContainer>
                <div className="subtitle">
                    <h2>
                        <FormattedMessage id="home_title_5" defaultMessage="Nuevos en Fluincr" />
                    </h2>
                    <p className="seeMore" onClick={() => {
                        setNewUserFilter(true)
                        navigate('/influencers')
                    }}>
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </p>
                </div>

                <div className="content">
                    <div className="cards influencers">
                        {newInfluencers.map((influencer) => (
                            <InfluencerCard influencer={influencer} key={influencer.id} page='home' />
                        ))}
                    </div>
                    <p className="seeMoreMobile" onClick={() => {
                        setNewUserFilter(true)
                        navigate('/influencers')
                    }}>
                        <FormattedMessage id="home_more_text" defaultMessage="Ver más +" />
                    </p>
                </div>
            </ SectionsContainer>

            < LastSliderContainer>
                <div className="subtitle">
                    <h2>
                        <FormattedMessage id="home_title_6" defaultMessage="Redes Sociales" />
                    </h2>
                </div>

                <div className="sliderContainerNetwork" >
                    < Slider {...settingSliderNetwork}>
                        {
                            networksOptions.map((network) => (
                                <FilterCard filter={network} key={network.id} type={'network'} />
                            ))
                        }
                    </Slider >
                </div>
            </ LastSliderContainer>

        </HomeContainer >

    )
}